import React, { Component, useEffect, useState } from "react";
// import "./Mail.css";
export default class Mail2 extends React.Component {
  render() {
    return <table></table>;
  }
}
